<template>
  <v-app id="app-main">
    <router-view />
  </v-app>
</template>

<style>
@import url('https://fonts.googleapis.com/css2?family=Sarabun:wght@300;400;500;700&display=swap');

#app-main {
  background-color: #f5f5f5 !important;
  font-family: 'Sarabun', sans-serif !important;
}
/* Ensure body also has the background */
body {
  background-color: #f5f5f5 !important;
  margin: 0;
}

/* Custom Scrollbar for Webkit browsers */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
::-webkit-scrollbar-track {
  background: #1e1e1e; 
}
::-webkit-scrollbar-thumb {
  background: #d4af37; 
  border-radius: 4px;
}
::-webkit-scrollbar-thumb:hover {
  background: #b59025; 
}
</style>

<script>
export default {
  methods: {},
};
</script>
<style>
@import "./assets/styles.css";
</style>
